import { Box, Stack } from "@chakra-ui/react";

export const data = [
    {
        key: 'editor',
        label: "Fast sitemap editing",
        description: "Rarchy's real-time collaborative drag and drop editor makes it easy to create your perfect visual sitemap, whether your website is large or small.",
        imgSrc: "/images/sitemap-editor/editor.webp"
    },
    {
        key: 'collaborate',
        label: "Collaborate in one place",
        description: (
            <Stack spacing={6}>
                <Box>
                    Stay aligned and avoid duplicating work using Rarchy as a single source of truth.
                </Box>
                <Box>
                    Save time on back-and forth conversations over email or Slack with real-time comments, including @mentions, resolving and email notifications.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/sitemap-editor/collaborate.webp"
    },
    {
        key: 'screenshots',
        label: "Capture full-page screenshots",
        description: (
            <Stack spacing={6}>
                <Box>
                    Capture full-page screenshots of every page on your website to get a truly visual view, whether it's to wow your clients or simply archive your page content.
                </Box>
                <Box>
                    <strong>Tip: </strong> Scroll the image for a full-page example.
                </Box>
            </Stack>
        ),
        imgSrc: `/images/sitemap-editor/screenshots.webp`,
        imgH: 520
    },
    {
        key: 'sections',
        label: "Page section blocks",
        description: (
            <Stack spacing={6}>
                <Box>
                    Plan your page content by adding individual page sections within your visual sitemap.
                </Box>
                <Box>
                    Choose from a selection of wireframe templates for each page section to make content planning more visual.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/sitemap-editor/sections.webp"
    },
    {
        key: 'wireframes',
        label: "250+ wireframe templates",
        description: (
            <Stack spacing={6}>
                <Box>
                    Planning new pages?
                </Box>
                <Box>
                    Choose from over 250+ low-fidelity wireframe templates, handily grouped into 12 categories for searching.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/sitemap-editor/wireframes.webp"
    },
    {
        key: 'search',
        label: "Speedy searching",
        description: (
            <Stack spacing={6}>
                <Box>
                    Big website? No problem.
                </Box>
                <Box>
                    Navigate straight to the pages you're working on with page search, so you can work quickly and efficiently, even on the largest of websites.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/sitemap-editor/search.webp"
    },
]